import Trans from 'next-translate/Trans';
import Link from 'next/link';

// Hooks
import { usePathname } from 'next/navigation';
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';
import useAcl from '@/utils/hooks/user/useAcl';

// Routing
import { CHANGE_YOUR_PLAN } from '@/lib/settings/subscriptionInvoices/steps';
import {
    ANALYZE_ENGAGEMENT,
    ANALYZE_OVERVIEW,
    CONTENT_POSTS,
    SUBSCRIPTION_INVOICES
} from '@/lib/routes/privateRoutes';

// Lib
import { aclFeatures } from '@/lib/acl/aclFeatures';

export const PromotedPostsUpsellBanner = () => {
    const { hasAcl } = useAcl();
    const hasPermissions = hasAcl(aclFeatures.analytic.promoted_post.read);
    const pathname = usePathname();
    const { activeSocialProfile } = useActiveSocialProfile();

    if (
        !hasPermissions &&
        (pathname === CONTENT_POSTS ||
            ((pathname === ANALYZE_OVERVIEW || pathname === ANALYZE_ENGAGEMENT) &&
                activeSocialProfile?.social_network_type === 'instagram'))
    ) {
        return (
            <div
                className="w-full bg-icoGreen-100 p-4 text-center text-xs"
                data-testid="promoted-posts-upsell-banner">
                <Trans
                    i18nKey={'commons:upsell_banner.promoted_posts.text'}
                    components={{
                        bold: <span className="font-GBold" />,
                        link: (
                            <Link
                                href={{
                                    pathname: SUBSCRIPTION_INVOICES,
                                    query: { step: CHANGE_YOUR_PLAN }
                                }}
                                className="text-icoGreen underline"
                            />
                        )
                    }}
                />
            </div>
        );
    }
    return null;
};
